import { createSlice } from '@reduxjs/toolkit';

const modulesSlice = createSlice({
  name: 'modules',
  initialState: {
    loading: false,
    success: false,
    failed: false,
    error: null,
    lists: {
      recommended: [],
      optional: [],
    },
  },
  reducers: {
    fetchModulesData(state) {
      state.loading = true;
      state.error = null;
    },
    modulesDataSuccess(state, { payload }) {
      state.loading = false;
      state.failed = false;
      state.success = true;
      state.lists = payload;
    },
    modulesDataError(state, { payload }) {
      state.loading = false;
      state.failed = true;
      state.error = payload;
    },
  },
});

export const { fetchModulesData, modulesDataSuccess, modulesDataError } =
  modulesSlice.actions;

export default modulesSlice.reducer;
